import { Box, Toolbar as MUIToolbar } from '@mui/material';
import { styled } from '@mui/system';

export const Toolbar = styled(MUIToolbar)(({ theme }) => ({
	justifyContent: 'space-between',
	// boxShadow: '7px 4px 30px 0px rgba(130, 125, 131, 0.15)',
	padding: '0px 8px 0px 0px',
	background: 'rgba(255, 255, 255, 0.50)',

	borderRadius: '20px',
	[theme.breakpoints.down('sm')]: { padding: '0 4px', gap: '4px', minWidth: 0 },

	'&:has(.homework-modal)::before': {
		background: '#fff',
	},

	'&::before': {
		content: "''",
		position: 'absolute',
		inset: 0,
		background: 'rgba(255,255,255,0.3)',
		backdropFilter: 'blur(10px)',
		borderRadius: '32px',
		zIndex: '-1',
		transition: 'background .3s',
	},
}));

export const Right = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: '4px',
	[theme.breakpoints.down('sm')]: {
		flexShrink: 0,
		gap: '2px',
		'& .MuiIconButton-root': { width: '40px', height: '40px', padding: '8px', flexShrink: 0 },
		'& .MuiIconButton-root svg': { width: '20px', height: '20px' },
		'& .MuiBadge-badge': { fontSize: '10px', minWidth: '16px', height: '16px', padding: '0 4px' },
	},
}));

export const HeaderLanguage = styled('div')(({ theme }) => ({
	display: 'contents',
	[theme.breakpoints.down('sm')]: { display: 'none' },
}));

export const Body = styled(Box)({
	height: '100%',
	overflow: 'auto',
});
